import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
// import { logger } from "redux-logger";

import createRootReducer from './redux/reducers';

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [sagaMiddleware, routeMiddleware];
if (process.env.NODE_ENV === 'development' && true) {
  // middlewares.push(logger);
}

// Lazy-load the saga registry so the entire saga graph (every admin saga
// + transitive deps: parse SDK ~193 KB raw, core-js-pure, ramda, crypto-js,
// redux-form, all admin services) lands in its own async chunk instead of
// main.js. /inspection never fetches the chunk because it doesn't dispatch
// saga-handled actions. Admin paths show <Loader /> until the auth saga
// resolves auth state (auth reducer's INITIAL_STATE.loading is true), so
// MainLayout and its mount-dispatchers stay gated until sagas are ready.
export function bootstrapSaga() {
  import(/* webpackChunkName: "sagas" */ './redux/sagas')
    .then(({ default: sagas }) => sagaMiddleware.run(sagas))
    .catch((err) => {
      console.error('Failed to load sagas chunk:', err);
    });
}

export default function configureStore(preloadedState) {
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeEnhancer(applyMiddleware(...middlewares))
  );
  // sagaMiddleware.run(sagas); // Delay saga run

  // Hot reloading
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./redux/reducers', () => {
      store.replaceReducer(createRootReducer(history));
    });
  }

  return store;
}
